// Point Festival (พอยท์ แลก ลุ้น Season 7) — temporary special campaign.
// Uses the existing lucky draw backend (GET /lucky_draws, POST /lucky_draws/:id/join).
// To remove: set `enabled` to false (hides the button on /rewards).

export const POINT_FESTIVAL = {
  enabled: true,
  // pin a specific lucky draw id via env; otherwise the first active one is used
  luckyDrawId: process.env.VUE_APP_POINT_FESTIVAL_ID || null,
  // used when the lucky draw has no announceAt
  announceAt: "2026-12-17T15:00:00+07:00",
  // summary card on the activity page (from the campaign key visual)
  info: {
    period: "1-30 พ.ย. 69",
    periodNote: "สิ้นสุด 23.59 น.",
    rate: "1 พอยท์ = 1 สิทธิ์",
    eligible: "สำหรับร้านค้าปลีก ร้านอาหาร และร้านค้าเล็กอื่นๆ ช่องทางออนไลน์และออฟไลน์",
    drawAt: ["16 ธ.ค. 69", "เวลา 11.00 น."],
    announceAt: ["17 ธ.ค. 69", "เวลา 15.00 น."],
  },
};

// key visual — replace the file to update the artwork
export const POINT_FESTIVAL_KV = require("@/assets/point_festival_kv.jpg");
// landscape artwork for the top of the activity page (shown whole, not cropped)
export const POINT_FESTIVAL_BANNER = require("@/assets/point_festival_banner.jpg");

// Click/step tracking. Sent to Google Tag Manager as a custom event "point_festival"
// (GTM needs a trigger + GA4 tag for it), and to the legacy Matomo helper.
export function trackFestival(action, params = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "point_festival", festival_action: action, ...params });
  } catch (error) {
    console.log(error);
  }
  window.$pushEvent("point_festival", action, JSON.stringify(params));
}

export async function fetchPointFestival(jwt) {
  const res = await fetch(process.env.VUE_APP_API_URL + "/lucky_draws", {
    method: "GET",
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  });
  if (res.status !== 200) {
    throw "fetchPointFestival status " + res.status;
  }
  const list = (await res.json()) || [];
  if (POINT_FESTIVAL.luckyDrawId) {
    return list.find((item) => item.id == POINT_FESTIVAL.luckyDrawId) || null;
  }
  return (
    list.find((item) => item.isActive === true) ||
    // after the campaign ends, fall back to the latest one (for the winners page)
    list
      .slice()
      .sort((a, b) => new Date(b.announceAt || 0) - new Date(a.announceAt || 0))[0] ||
    null
  );
}

export function getAnnounceDate(luckyDraw) {
  return new Date((luckyDraw && luckyDraw.announceAt) || POINT_FESTIVAL.announceAt);
}

export function isAnnounced(luckyDraw) {
  return new Date() >= getAnnounceDate(luckyDraw);
}

// 20 พ.ย. 69
export function formatThaiShortDate(date) {
  return date.toLocaleDateString("th-TH", {
    day: "numeric",
    month: "short",
    year: "2-digit",
  });
}
